import { createSelector } from 'reselect'

import { AppState } from '../../../redux'

const getDateRange = (state: AppState) => state.dateRange

const getNumMonths = createSelector(getDateRange, (state) => state.numMonths)

export { getNumMonths }
